import { NotificationService } from './../../../common/services/notification/notification.service';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  GET_LOCATION_REQUESTED,
  GET_LOCATION_SUCCEEDED,
  GET_ALL_DESTINATION_SUCCEEDED,
  UPDATE_LOCATION_REQUESTED,
  UPDATE_LOCATION_SUCCEEDED,
  GET_ALL_DESTINATION_REQUESTED
} from './edit.actions';

function* getLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.location.getItemById(action.data).toPromise();
    yield put({ type: GET_LOCATION_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetLocationRequest() {
  yield takeEvery(GET_LOCATION_REQUESTED, getLocation);
}

function* getDestinations(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.destination.list().toPromise();
    yield put({ type: GET_ALL_DESTINATION_SUCCEEDED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetLocationSuccess() {
  yield takeEvery(GET_LOCATION_SUCCEEDED, getDestinations);
}

function* getAllDestinations() {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.destination.list().toPromise();
    yield put({ type: GET_ALL_DESTINATION_SUCCEEDED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetAllDestinationRequested() {
  yield takeEvery(GET_ALL_DESTINATION_REQUESTED, getAllDestinations);
}

function* updateLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.location.update(action.data).toPromise();
    yield put({ type: UPDATE_LOCATION_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateLocationRequest() {
  yield takeEvery(UPDATE_LOCATION_REQUESTED, updateLocation);
}

function* updateLocationSuccessed(action) {
  AppInjector.get(NotificationService).show('success', 'Location is updated', 3000);
}

function* watchUpdateLocationSuccessed() {
  yield takeEvery(UPDATE_LOCATION_SUCCEEDED, updateLocationSuccessed);
}

export default [watchGetLocationRequest, watchGetLocationSuccess, watchUpdateLocationRequest, watchUpdateLocationSuccessed, watchGetAllDestinationRequested];
